'use strict';

angular.module('basketModule')
.factory('basketViewOptions', basketViewOptions);

function basketViewOptions (
    extendDeep,
    resourceViewOptions,
    BasketService,
    basketListView,
    downloadAction
) {
    const options = angular.copy(resourceViewOptions);

    return extendDeep(options, {
        basketService: BasketService,
        totalDownloadSize: () => {
            const items = BasketService.get();
            return items.reduce((size, item) => size + item.file.size , 0);
        },
        with: ['thumbnail', 'file'],
        views: [basketListView],
        toolbar: [downloadAction],
        sorts: [{
            label: "Added",
            sort: "updated_at asc"
        }],
        list: {
            tableClass: 'table',
            columns: [
                {
                    label: 'Preview',
                    template: `<div class="file-preview">
                                    <div class="file-preview-image" 
                                         ng-style="{backgroundImage: 'url({{ model.thumbnail }})'}"></div>
                               </div>`,
                    sortable: false
                },
                {
                    label: 'Name',
                    template: `<p class="file-name">{{ model.file.filename }}</p>
                               <p class="file-size">{{ model.file.size | bytes }}</p>`,
                    sortable: false
                },
                {
                    label: '',
                    name: '',
                    template: `<button class="btn btn-danger"
                                       ng-click="options.basketService.remove(model.file)">
                                    Remove
                                </button>`,
                    sortable: false
                }

            ]
        },
    });

}
